export interface MenuItem {
  id: number;
  name: string;
  url: string;
  submenu?: MenuItem[];
}

export interface MenuList extends MenuItem {
  submenu?: MenuItem[];
}

export const menuList: MenuList[] = [
  {
    id: 1,
    name: "Home",
    url: "/",
  },
  {
    id: 2,
    name: "Service",
    url: "",
    submenu: [
      {
        id: 21,
        name: "Our Services",
        url: "/service",
       
      },
      {
        id: 22,
        name: "Hospital Wards & Rooms",
        url: "/service/ch-ward",
      },
    ],
  },

 
  {
    id: 3,
    name: "Pages",
    url: "",
    submenu: [
      {
        id: 31,
        name: "Gallery",
        url: "/pages/gallery",
      },
      {
        id: 32,
        name: "Blogs",
        url: "/pages/blogs",
      },
    ],
  },

 {
    id: 4,
    name: "About Us",
    url: "/about-us",
  },

  {
    id: 5,
    name: "Contact",
    url: "/contact-us",
  },
  {
    id: 6,
    name: "Careers",
    url: "/careers",
  },

];